import { render, staticRenderFns } from "./AddServiceModal.vue?vue&type=template&id=30ac7ee7&"
import script from "./AddServiceModal.vue?vue&type=script&lang=js&"
export * from "./AddServiceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30ac7ee7')) {
      api.createRecord('30ac7ee7', component.options)
    } else {
      api.reload('30ac7ee7', component.options)
    }
    module.hot.accept("./AddServiceModal.vue?vue&type=template&id=30ac7ee7&", function () {
      api.rerender('30ac7ee7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/branches/AddServiceModal.vue"
export default component.exports